<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attr }">
      <v-btn
        v-bind="attr"
        v-on="on"
        @click.stop
        :to="newPageRoute" target="_blank"
        icon
        small
      >
        <v-icon color="orange" dense>
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    {{ tooltipText }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'OpenItemPage',
  props: {
    itemId: {
      type: Number,
    },

    itemRoute: {
      type: String,
    },

    tooltipText: {
      type: String,
      default: 'open page',
    },

    icon: {
      type: String,
      default: 'mdi-pen',
    },
  },

  data: () => ({
  }),

  computed: {
    newPageRoute() {
      return `${this.itemRoute}/${this.itemId}`;
    },
  },
};
</script>

<style scoped>

</style>
